export default [
  {
    leistungstext: "Sturm/Hagel",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Überschwemmung/Überflutung",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Anhaltende Regengüsse",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Höhere Gewalt",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Folgekosten durch Konstruktions-, Herstellungs- und Materialfehler",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Schäden durch vorsätzliches Verhalten Dritter",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Glasbruchschäden",
    infoText: "",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Diebstahl mit dem Gebäude fest verbundener versicherter Bestandteile",
    infoText: "z.B. verbundene Fenster, Sanitärinstallationen und weitere versicherte Sachen",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Graffitischäden",
    infoText: "Sachbeschädigung der Baumaßnahme z.B. durch Graffiti",
    leistungen: ["Ja"],
  },
  {
    leistungstext: "Transportschäden versicherter Sachen zwischen Baustelle und Lagerungsort",
    infoText: "",
    leistungen: ["Nein"],
  },
  {
    leistungstext: "Selbstbeteiligung je Schadenfall",
    infoText: "",
    leistungen: ["250 €"],
    leistungsstil: "selbstbeteiligung",
  },
];
